export default {
      id: "copy-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#copy",
      toString: function () {
        return this.url;
      }
    }